export const REVIEWS = [
  {
    name: "Imran K.",
    location: "Manchester",
    rating: 5,
    text: "Rented a hybrid through EazyCarTrack and was on the road the same week. Clean car, clear weekly price and no messing about. WhatsApp made it so easy to sort.",
  },
  {
    name: "Daniel O.",
    location: "Salford",
    rating: 5,
    text: "Straightforward from start to finish. They explained exactly what I needed for my private hire badge and the insurance option saved me a lot of hassle.",
  },
  {
    name: "Farhan A.",
    location: "Bolton",
    rating: 5,
    text: "Great fuel economy on the hybrid, which makes a real difference doing Uber and Bolt work all week. Would recommend to any PHV driver in Manchester.",
  },
  {
    name: "Michael T.",
    location: "Rochdale",
    rating: 4,
    text: "Fair weekly rates and the car was well maintained. Communication over WhatsApp was quick and honest about availability.",
  },
  {
    name: "Sana R.",
    location: "Oldham",
    rating: 5,
    text: "First time renting a PHV and they walked me through everything. Manchester based, easy collection and a proper rental agreement. Very happy.",
  },
];
